import React from 'react';

const NoiseOverlay: React.FC = () => {
  return <div className="noise-overlay" aria-hidden="true" />;
};

export default NoiseOverlay;

